<script lang="ts">
	//Formating
	import { format } from '../../services/i18n';
	//Design system components
	import { ControlsContainer, Loader, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { capFirstChar } from '../../helpers/utilities';
	//Components
	import Chart from '../Chart/Chart.svelte';
	//Chart Config
	import { getDynamicChartConfig } from '../Chart/chart_config';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let roomsCurrentConsList = {};

	const includedRooms = {},
		generateChartData = (roomsObjList) => {
			let currentValues = [],
				excludedValues = [],
				labels = [];
			Object.values(roomsObjList).forEach((el: any) => {
				const isConsumption = el.in_power || el.ex_power;
				if (isConsumption || includedRooms[el.id]) {
					if (!includedRooms[el.id]) {
						includedRooms[el.id] = 1;
					}
					currentValues = [...currentValues, el.in_power];
					excludedValues = [...excludedValues, el.ex_power];
					labels = [...labels, el.title];
				}
			});
			return {
				currentValues,
				excludedValues,
				labels,
				xGrid: true,
			};
		};

	$: chartData = getDynamicChartConfig(generateChartData(roomsCurrentConsList));
</script>

<ControlsContainer color={$showNewLayout ? 'color-1' : 'color-2'}>
	<svelte:fragment slot="first">
		<Text class="text-bold"
			>{capFirstChar(
				$format('text_energy_distribution_by_rooms', {
					default: 'Energy Distribution By Rooms',
				}),
			)}</Text
		>
		{#if !chartData.loaded}
			<div
				class="d-flex justify-content-center align-items-center"
				style={`height: ${chartData.height}px`}
			>
				<Loader size="m" />
			</div>
		{:else}
			<Chart {chartData} />
		{/if}
	</svelte:fragment>
</ControlsContainer>
